import { FunctionComponent } from "react";

interface UnreadableFilterRowsProps {
	/** The stored filters nothing can be read from, by key. */
	entries: Record<string, unknown>;
	onRemove: (key: string) => void;
}

/**
 * The filters of a list that could not be read (PREC-4622). The API lets no lead past them, so
 * the step must not hide them either: a hidden one would vanish on the next save and widen the
 * list. Each stays until the user removes it here or sets a filter of the same name again; the
 * exclusion reason on the held-back leads says the same ("remove it or set it again").
 */
export const UnreadableFilterRows: FunctionComponent<UnreadableFilterRowsProps> = ({
	entries,
	onRemove,
}) => {
	const keys = Object.keys(entries);

	if (keys.length === 0) {
		return null;
	}

	return (
		<div className="border p-6 mb-8 w-full rounded-xl border-1 border-status-error bg-status-error-light flex flex-col gap-3 text-left">
			{keys.map((key) => (
				<div className="flex flex-row items-center gap-4" key={key}>
					<div className="grow text-sm text-text">
						<span className="font-bold">{key}</span>: This filter could not be read — remove it or
						set it again. Until then no lead passes it.
					</div>
					<button
						aria-label={`Remove ${key}`}
						className="text-sm font-semibold text-status-error hover:underline"
						onClick={() => onRemove(key)}
						type="button"
					>
						Remove
					</button>
				</div>
			))}
		</div>
	);
};
